var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

define(function () {
  "use strict"; // All support tests are defined in their respective modules.

  return {};
});